import { gql } from '@apollo/client';
import React from 'react';
import { Product } from 'schema-dts';
import { useLocation } from 'react-router-dom';
import { Availability } from '@moda/portal-stanchions';
import { SchemaOrgProductDetailPageFragment } from '../../generated/types';

export const CANONICAL_ROOT = 'https://www.modaoperandi.com';

export const SCHEMA_ORG_PRODUCT_DETAIL_PAGE_FRAGMENT = gql`
  fragment SchemaOrgProductDetailPageFragment on Variant {
    id
    name
    available
    availability
    descriptionText: description_text
    designerName: designer_name
    masterVariant: master_variants_data {
      id
      color
      primaryImage: primary_image_urls {
        large
      }
      prices(country_code: $countryCode) {
        currentPrice: current_price {
          currency
          price
        }
      }
    }
  }
`;

interface Props {
  variant: SchemaOrgProductDetailPageFragment;
}

export const SchemaOrgProductDetailPage: React.FC<Props> = ({ variant }) => {
  const { pathname } = useLocation();
  const schema: Product = {
    '@type': 'Product',
    productID: variant.id,
    name: variant.name || '',
    description:
      variant.descriptionText.trim() || `${variant.name} by ${variant.designerName}` || '',
    url: `${CANONICAL_ROOT}${pathname}`,
    color: variant.masterVariant.color || '',
    image: variant.masterVariant.primaryImage.large || '',
    brand: {
      '@type': 'Brand',
      name: variant.designerName
    },
    offers: {
      '@type': 'Offer',
      availability: variant.available
        ? Number(variant.availability) === Availability.AvailableNow
          ? 'https://schema.org/InStock'
          : 'https://schema.org/PreOrder'
        : 'https://schema.org/OutOfStock',
      priceCurrency: variant.masterVariant.prices.currentPrice?.currency || '',
      price: variant.masterVariant.prices.currentPrice?.price || ''
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};
